/**
 * Labstep
 *
 * @module components/Layout/Links
 * @desc Navlinks + Switch
 */

import classnames from 'classnames';
import { Icon } from 'labstep-web/core/Icon';
import { NavLink } from 'labstep-web/core/NavLink';
import { PremiumFeatureLockIcon } from 'labstep-web/core/PremiumFeature/LockIcon';
import { Switch } from 'labstep-web/core/Switch';
import type React from 'react';
import styles from './styles.module.scss';
import type { LayoutLinksProps } from './types';

export const LayoutLinks: React.FC<LayoutLinksProps> = ({
  links,
  inverted,
  fluid,
  stretch,
  noBottomMargin,
}) => (
  <div className={styles.container}>
    <div
      className={classnames(styles.linksContainer, {
        [styles.fluid]: fluid,
        [styles.noBottomMargin]: noBottomMargin,
      })}
    >
      {links.map((link, index) => (
        <NavLink
          // FIXME react/no-array-index-key
          key={index}
          exact
          className={classnames(styles.link, {
            [styles.inverted]: inverted,
            [styles.stretch]: stretch,
            [styles.stretchInverted]: stretch && inverted,
          })}
          to={link.route.to}
          params={link.route.params}
          query={link.route.query}
        >
          {link.icon && <Icon name={link.icon} />}
          {link.children}
          {link.premiumFeature && (
            <PremiumFeatureLockIcon
              premiumFeature={link.premiumFeature}
            />
          )}
        </NavLink>
      ))}
      {inverted && !stretch && <div className={styles.barrier} />}
    </div>
    <Switch
      links={links.map((link) => ({
        render: link.render,
        route: { to: link.route.to },
      }))}
    />
  </div>
);
